import { ArrowRight, Check, Clock } from "lucide-react"
import { useNavigate } from "react-router-dom"
import { PORTAL_ROUTES } from "utils/constants"
import StatusBadge from "components/StatusBadge"

const Item = ({ item, completion, nextStepId }) => {
  const navigate = useNavigate();
  let { title, description, id, time } = item || {}
  let isCompleted = completion[id]
  let isDisabled = nextStepId !== id && !isCompleted

  return (
    <button
      type="button"
      disabled={isDisabled}
      onClick={() => navigate(`${PORTAL_ROUTES.PROFILE}/${id}`)}
      className={`group w-full text-left border border-gray-100 rounded-2xl p-5 flex flex-col gap-3 transition-shadow focus:outline-none focus-visible:ring-2 focus-visible:ring-primary-500 focus-visible:ring-offset-2 ${isDisabled ? "bg-gray-100 grayscale opacity-60 pointer-events-none" : "bg-white cursor-pointer hover:shadow-sm"}`}
    >
      <p className="font-semibold text-secondary-900">{title}</p>

      <StatusBadge
        status={isCompleted ? "Complete" : "Pending"}
        className={isCompleted ? "bg-success-50 text-green-700 border-green-200" : "bg-primary-50 text-primary-700 border-primary-200"}
        icon={isCompleted ? Check : Clock}
      />

      <p className="text-sm text-secondary-400 mt-0.5">{description}</p>

      <div className="flex items-center justify-between mt-auto pt-1 w-full">
        <span className="inline-flex items-center gap-1 text-sm font-semibold transition-colors text-secondary-900 group-hover:text-secondary-600">
          {isCompleted ? 'View & edit' : 'Start'}
          <ArrowRight size={14} />
        </span>
        <span className="text-xs text-secondary-400">{time}</span>
      </div>
    </button>
  )
}

export default Item
